"use client";

import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";
import {
  ChevronDownIcon,
  HomeModernIcon,
  ScaleIcon,
  EnvelopeIcon,
  PhoneIcon,
  UserIcon,
  BuildingLibraryIcon,
  ClipboardDocumentListIcon,
  LifebuoyIcon
} from "@heroicons/react/20/solid";
import Link from "next/link";

export default function Menus() {
  return (
    <div className=" text-right ">
      <Menu as="div" className="relative inline-block text-center  ">
        <div>
          <Menu.Button className=" inline-flex  w-full justify-around rounded-md bg-yellow-600 bg-opacity-50 px-6  py-2 text-sm font-medium text-black  dark:text-white  hover:bg-opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
            Order An Appraisal
            <ChevronDownIcon
              className="ml-2 -mr-1 animate-bounce h-5 w-5 text-blue-500 hover:text-violet-100"
              aria-hidden="true"
            />
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className=" absolute right-0 p-5 dark:bg-zinc-900 mt-2 w-auto origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black dark:ring-blue-500 ring-opacity-5 focus:outline-none">
            <div className="px-1 py-1 dark:bg-zinc-900  text-base sm:text-xl ">
              <Menu.Item>
                {({ active }) => (
                  <Link href="/order/property-owner">
                    <div
                      className={`${
                        active ? "bg-blue-500 text-white" : "text-blue-500"
                      } group flex w-full items-center rounded-md px-2 py-2`}
                    >
                      {active ? (
                        <HomeModernIcon
                          className="mr-2 h-5 w-5"
                          aria-hidden="true"
                        />
                      ) : (
                        <HomeModernIcon
                          className="mr-2 h-5 w-5"
                          aria-hidden="true"
                        />
                      )}
                      Property Owner
                    </div>
                  </Link>
                )}
              </Menu.Item>{" "}
              <Menu.Item>
                {({ active }) => (
                  <Link href="/order/buyers">
                    <div
                      className={`${
                        active ? "bg-blue-500 text-white" : "text-blue-500"
                      } group flex w-full items-center rounded-md px-2 py-2 `}
                    >
                      {active ? (
                        <UserIcon className="mr-2 h-5 w-5" aria-hidden="true" />
                      ) : (
                        <UserIcon className="mr-2 h-5 w-5" aria-hidden="true" />
                      )}
                      Home Buyers
                    </div>
                  </Link>
                )}
              </Menu.Item>
              <Menu.Item>
  {({ active }) => (
    <Link href="/order/probate-estate">
      <div
        className={`${
          active ? "bg-blue-500 text-white" : "text-blue-500"
        } group flex w-full items-center rounded-md px-2 py-2`}
      >
        {active ? (
          <ClipboardDocumentListIcon className="mr-2 h-5 w-5" aria-hidden="true" />
        ) : (
          <ClipboardDocumentListIcon className="mr-2 h-5 w-5" aria-hidden="true" />
        )}
        Probate Estate 
      </div>
    </Link>
  )}
</Menu.Item>

              <Menu.Item>
                {({ active }) => (
                  <Link href="/order/broker-lender">
                    <button
                      className={`${
                        active ? "bg-blue-500 text-white" : "text-blue-500"
                      } group flex w-full items-center rounded-md px-2 py-2 `}
                    >
                      {active ? (
                        <BuildingLibraryIcon
                          className="mr-2 h-5 w-5"
                          aria-hidden="true"
                        />
                      ) : (
                        <BuildingLibraryIcon
                          className="mr-2 h-5 w-5"
                          aria-hidden="true"
                        />
                      )}
                      Broker/Lender
                    </button>{" "}
                  </Link>
                )}
              </Menu.Item>{" "}
              <Menu.Item>
                {({ active }) => (
                  <Link href="/order/lawyer-accountant-other">
                    <button
                      className={`${
                        active ? "bg-blue-500 text-white" : "text-blue-500"
                      } group flex w-full items-center rounded-md px-2 py-2`}
                    >
                      {active ? (
                        <ScaleIcon
                          className="mr-2 h-5 w-5"
                          aria-hidden="true"
                        />
                      ) : (
                        <ScaleIcon
                          className="mr-2 h-5 w-5"
                          aria-hidden="true"
                        />
                      )}
                      Lawyer/Accountant
                    </button>{" "}
                  </Link>
                )}
              </Menu.Item>{" "}
              <Menu.Item>
                {({ active }) => (
                  <Link href="/order/proposal-insolvency">
                    <button
                      className={`${
                        active ? "bg-blue-500 text-white" : "text-blue-500"
                      } group flex w-full items-center rounded-md px-2 py-2`}
                    >
                      {active ? (
                        <ClipboardDocumentListIcon
                          className="mr-2 h-5 w-5"
                          aria-hidden="true"
                        />
                      ) : (
                        <ClipboardDocumentListIcon
                          className="mr-2 h-5 w-5"
                          aria-hidden="true"
                        />
                      )}
                      Proposal/Insolvency
                    </button>{" "}
                  </Link>
                )}
              </Menu.Item>{" "}
              <Menu.Item>
                {({ active }) => (
                  <Link href="/order/power-of-sale">
                    <button
                      className={`${
                        active ? "bg-blue-500 text-white" : "text-blue-500"
                      } group flex w-full items-center rounded-md px-2 py-2`}
                    >
                      {active ? (
                        < LifebuoyIcon
                          className="mr-2 h-5 w-5"
                          aria-hidden="true"
                        />
                      ) : (
                        < LifebuoyIcon
                          className="mr-2 h-5 w-5"
                          aria-hidden="true"
                        />
                      )}
                      Power of Sale
                    </button>{" "}
                  </Link>
                )}
              </Menu.Item>{" "}
            </div>
            <div className="px-1 py-2  dark:bg-zinc-900 dark:text-white ">
              {" "}
              <a href="tel:416-450-2336">
                <Menu.Item>
                  {({ active }) => (
                    <button
                      className={`${
                        active
                          ? "bg-white text-black"
                          : "bg-blue-500 text-white dark:text-white"
                      } group flex w-full items-center rounded-md px-2 py-2 `}
                    >
                      {active ? (
                        <PhoneIcon
                          className="mr-2 h-5 w-5"
                          aria-hidden="true"
                        />
                      ) : (
                        <PhoneIcon
                          className="mr-2 h-5 w-5"
                          aria-hidden="true"
                        />
                      )}
                      (416)-450-2336
                    </button>
                  )}
                </Menu.Item>{" "}
              </a>
              <Menu.Item>
                <a href="mailto:info@alphaappraisals.ca">
                  <div className="bg-white text-black  dark:text-white dark:bg-zinc-900    group flex w-full items-center rounded-md px-2 py-2 text-sm">
                    <EnvelopeIcon className="mr-2 h-5 w-5" aria-hidden="true" />{" "}
                    info@alphaappraisals.ca
                  </div>{" "}
                </a>
              </Menu.Item>
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
}

function EditInactiveIcon(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 13V16H7L16 7L13 4L4 13Z"
        fill="#EDE9FE"
        stroke="#A78BFA"
        strokeWidth="2"
      />
    </svg>
  );
}

function EditActiveIcon(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 13V16H7L16 7L13 4L4 13Z"
        fill="#8B5CF6"
        stroke="#C4B5FD"
        strokeWidth="2"
      />
    </svg>
  );
}

function DuplicateInactiveIcon(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 4H12V12H4V4Z"
        fill="#EDE9FE"
        stroke="#A78BFA"
        strokeWidth="2"
      />
      <path
        d="M8 8H16V16H8V8Z"
        fill="#EDE9FE"
        stroke="#A78BFA"
        strokeWidth="2"
      />
    </svg>
  );
}

function DuplicateActiveIcon(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 4H12V12H4V4Z"
        fill="#8B5CF6"
        stroke="#C4B5FD"
        strokeWidth="2"
      />
      <path
        d="M8 8H16V16H8V8Z"
        fill="#8B5CF6"
        stroke="#C4B5FD"
        strokeWidth="2"
      />
    </svg>
  );
}

function ArchiveInactiveIcon(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="5"
        y="8"
        width="10"
        height="8"
        fill="#EDE9FE"
        stroke="#A78BFA"
        strokeWidth="2"
      />
      <rect
        x="4"
        y="4"
        width="12"
        height="4"
        fill="#EDE9FE"
        stroke="#A78BFA"
        strokeWidth="2"
      />
      <path d="M8 12H12" stroke="#A78BFA" strokeWidth="2" />
    </svg>
  );
}

function ArchiveActiveIcon(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="5"
        y="8"
        width="10"
        height="8"
        fill="#8B5CF6"
        stroke="#C4B5FD"
        strokeWidth="2"
      />
      <rect
        x="4"
        y="4"
        width="12"
        height="4"
        fill="#8B5CF6"
        stroke="#C4B5FD"
        strokeWidth="2"
      />
      <path d="M8 12H12" stroke="#A78BFA" strokeWidth="2" />
    </svg>
  );
}

function MoveInactiveIcon(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10 4H16V10" stroke="#A78BFA" strokeWidth="2" />
      <path d="M16 4L8 12" stroke="#A78BFA" strokeWidth="2" />
      <path d="M8 6H4V16H14V12" stroke="#A78BFA" strokeWidth="2" />
    </svg>
  );
}

function MoveActiveIcon(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10 4H16V10" stroke="#C4B5FD" strokeWidth="2" />
      <path d="M16 4L8 12" stroke="#C4B5FD" strokeWidth="2" />
      <path d="M8 6H4V16H14V12" stroke="#C4B5FD" strokeWidth="2" />
    </svg>
  );
}

function DeleteInactiveIcon(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="5"
        y="6"
        width="10"
        height="10"
        fill="#EDE9FE"
        stroke="#A78BFA"
        strokeWidth="2"
      />
      <path d="M3 6H17" stroke="#A78BFA" strokeWidth="2" />
      <path d="M8 6V4H12V6" stroke="#A78BFA" strokeWidth="2" />
    </svg>
  );
}

function DeleteActiveIcon(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="5"
        y="6"
        width="10"
        height="10"
        fill="#8B5CF6"
        stroke="#C4B5FD"
        strokeWidth="2"
      />
      <path d="M3 6H17" stroke="#C4B5FD" strokeWidth="2" />
      <path d="M8 6V4H12V6" stroke="#C4B5FD" strokeWidth="2" />
    </svg>
  );
}
